module.exports = __webpack_public_path__ + "static/media/breathe-in-the-words.f655b45c.jpg";